import { GalleryMobile } from './GalleryMobile';

export type { TypeGalleryMobileProps } from './types';
export default GalleryMobile;
